module.exports = __webpack_public_path__ + "img/img-lao-kyc.9c99c445.svg";